<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="title"
    :items="academicPeriods"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    clearable
    :loading="loading"
    :hide-details="hideDetail"
  >
    <template v-slot:[`item`]="{ item }"> {{ item.code }} - {{ item.title }} </template>
    <template v-slot:[`selection`]="{ item }">{{ item.code }} - {{ item.title }}</template>
  </v-autocomplete>
</template>

<script>
import { AcademicPeriod } from '@/plugins/api'

export default {
  data: () => ({
    academicPeriods: [],
    loading: false,
  }),
  props: {
    filters: Object,
    options: Object,
    hideDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    this.fetchAllAcademicPeriods()
  },
  methods: {
    async fetchAllAcademicPeriods(query) {
      this.loading = true
      const params = {
        ...this.filters,
        ...query,
        _limit: -1,
      }
      this.academicPeriods = await AcademicPeriod.fetch(params)
      this.loading = false
    },
    async update() {},
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filters(newVale) {
      if (newVale) this.fetchAllAcademicPeriods(newVale)
    },
  },
}
</script>

<style scoped></style>
